<script setup lang="ts">
import ErrorMessage from '@/overlays/ErrorMessage.vue';
import { eventBus } from '@/utils/eventBus';
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const visible = ref(false);
const errorText = ref<string>();

const { t } = useI18n();

const handleError = (message: string | undefined) => {
  visible.value = true;
  errorText.value = message || t('global.error_suggestion');
};

const handleClose = () => {
  visible.value = false;
  errorText.value = undefined;
};

const showError = (message: string) => {
  handleError(message);
};

onMounted(() => {
  eventBus.on('anErrorOccurred', handleError);
  eventBus.on('error', showError);
});

onBeforeUnmount(() => {
  eventBus.off('anErrorOccurred', handleError);
  eventBus.off('error', showError);
});
</script>

<template>
  <ErrorMessage v-if="visible" :description="errorText" @close="handleClose" />
</template>
